import script from "./SortingDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./SortingDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./SortingDropdown.vue?vue&type=style&index=0&id=0ffdfb22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffdfb22"]])

export default __exports__